var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[_vm._t("default"),(_vm.error)?_c('FormError',{domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }